// Module-level body scroll-lock counter. Modal nesting coordinates here so a
// child modal closing doesn't unlock scroll while the parent is still open.

let count = 0;
let priorOverflow: string | null = null;

export function acquireScrollLock(): void {
    if (typeof document === 'undefined') return;
    if (count === 0) {
        priorOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
    }
    count++;
}

export function releaseScrollLock(): void {
    if (typeof document === 'undefined') return;
    count = Math.max(0, count - 1);
    if (count === 0) {
        document.documentElement.style.overflow = priorOverflow ?? '';
        priorOverflow = null;
    }
}

/** Test-only: read the current depth. */
export function _scrollLockDepth(): number {
    return count;
}
